function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
import { useEffect } from 'react';
import { useEventQueue } from "./useEventQueue";
import commonPool from "../store/commonPool";
import { handleCreateOrder } from "../utils/payment";
import { Toast } from 'antd-mobile';
import { scrollToAnchor } from "../utils";
export var useEventPerform = function useEventPerform(props) {
  var interactionListSchema = props.interactionListSchema,
    userInfo = props.userInfo,
    product = props.product,
    compsGuid = props.compsGuid,
    hasBuy = props.hasBuy,
    hasChooseProduct = props.hasChooseProduct,
    isDev = props.isDev,
    isPreview = props.isPreview,
    visible = props.visible,
    setVisible = props.setVisible,
    productInfo = props.productInfo,
    search = props.search,
    payType = props.payType,
    params = props.params;
  var _useEventQueue = useEventQueue({
      interactionListSchema: interactionListSchema
    }),
    eventQueue = _useEventQueue.eventQueue,
    removeEvent = _useEventQueue.removeEvent,
    initEvent = _useEventQueue.initEvent,
    setEventQueue = _useEventQueue.setEventQueue;
  useEffect(function () {
    if ((eventQueue === null || eventQueue === void 0 ? void 0 : eventQueue.length) < 0 || (eventQueue === null || eventQueue === void 0 ? void 0 : eventQueue.length) === (interactionListSchema === null || interactionListSchema === void 0 ? void 0 : interactionListSchema.length)) return;
    if ((eventQueue === null || eventQueue === void 0 ? void 0 : eventQueue.length) === 0) return setEventQueue(interactionListSchema);
    handleEventPerform(eventQueue[0]);
  }, [eventQueue]);
  var handleOrderSubmit = function handleOrderSubmit(item, userInfoInput) {
    // 已购买时跳过
    if (hasBuy) return initEvent === null || initEvent === void 0 ? void 0 : initEvent();
    // 无选择商品时，跳过
    if (!hasChooseProduct && !isDev) return initEvent === null || initEvent === void 0 ? void 0 : initEvent();
    // 不配置订单确认页时，默认按钮不为创建订单按钮
    if (!(item !== null && item !== void 0 && item.value)) return;
    // 配置为n时
    if ((item === null || item === void 0 ? void 0 : item.value) === 'n') {
      // 开发环境无价格，需要在无价格的情况下唤起支付页
      if (!visible && ((product === null || product === void 0 ? void 0 : product.price) > 0 || isDev || isPreview) && !hasBuy) {
        setVisible(true);
      } else {
        if (isDev) {
          Toast.show({
            content: '支付成功'
          });
          setVisible(false);
          return;
        }
        var cusProps = _objectSpread(_objectSpread({}, props), {}, {
          search: search,
          userInfo: (userInfoInput === null || userInfoInput === void 0 ? void 0 : userInfoInput.userInfo) || (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userInfo),
          product: product,
          productInfo: productInfo,
          payType: payType,
          closePayModal: function closePayModal() {
            removeEvent(item === null || item === void 0 ? void 0 : item.key);
            setVisible(false);
          }
        });
        handleCreateOrder(cusProps);
      }
    } else {
      var url = "/orderpay".concat(params.activityId ? "/".concat(params.activityId) : '', "/").concat(product === null || product === void 0 ? void 0 : product.id).concat(search);
      if (location) location.href = url;
    }
  };
  var handleEventPerform = function handleEventPerform(item) {
    if ((eventQueue === null || eventQueue === void 0 ? void 0 : eventQueue.length) < 1) return;
    var needLogin = !(userInfo !== null && userInfo !== void 0 && userInfo.accessToken) || (userInfo === null || userInfo === void 0 ? void 0 : userInfo.needPhoneBind);
    if (item.title === 'anchor') {
      var _Object$keys;
      scrollToAnchor(item.value);
      if ((_Object$keys = Object.keys(product)) !== null && _Object$keys !== void 0 && _Object$keys.length) removeEvent(item === null || item === void 0 ? void 0 : item.key);
    } else if (item.title === 'modal') {
      var refs = commonPool.getRefs();
      // 判断是否登录弹窗
      for (var key in refs) {
        if (refs[key].title === item.value && refs[key].widget === 'SmLogin' && !needLogin) {
          return removeEvent(item === null || item === void 0 ? void 0 : item.key);
        } else if (refs[key].title === item.value && refs[key].widget === 'SmMultiProductsModal' && hasBuy) {
          // 已购买时不打开多商品弹窗
          return;
        }
      }
      // 需要弹窗时，需要吧点击的组件的标记传给弹窗组件，根据标记去调取对应的组件的方法
      for (var _key in refs) {
        if (refs[_key].title === item.value) {
          var _refs$_key, _refs$_key$ref, _refs$_key$ref$curren, _refs$_key2, _refs$_key2$ref, _refs$_key2$ref$curre, _refs$_key2$ref$curre2, _refs$_key2$ref$curre3;
          (_refs$_key = refs[_key]) === null || _refs$_key === void 0 ? void 0 : (_refs$_key$ref = _refs$_key.ref) === null || _refs$_key$ref === void 0 ? void 0 : (_refs$_key$ref$curren = _refs$_key$ref.current) === null || _refs$_key$ref$curren === void 0 ? void 0 : _refs$_key$ref$curren.chooseElement(compsGuid);
          (_refs$_key2 = refs[_key]) === null || _refs$_key2 === void 0 ? void 0 : (_refs$_key2$ref = _refs$_key2.ref) === null || _refs$_key2$ref === void 0 ? void 0 : (_refs$_key2$ref$curre = _refs$_key2$ref.current) === null || _refs$_key2$ref$curre === void 0 ? void 0 : (_refs$_key2$ref$curre2 = (_refs$_key2$ref$curre3 = _refs$_key2$ref$curre).openModal) === null || _refs$_key2$ref$curre2 === void 0 ? void 0 : _refs$_key2$ref$curre2.call(_refs$_key2$ref$curre3);
        }
      }
      // 打开登录弹窗时，中断操作，剩余操作在登录成功后执行
    } else if (item.title === 'confirm') {
      // 选择了跳转确认订单页
      handleOrderSubmit(item, userInfo);
    }
  };
  var handleEventStart = function handleEventStart() {
    console.log(eventQueue, 'handleEventPerform');
    handleEventPerform(eventQueue[0]);
  };
  return {
    handleEventStart: handleEventStart,
    eventQueue: eventQueue,
    removeEvent: removeEvent,
    initEvent: initEvent
  };
};